import React from "react";
import { Step } from "./Step";
import "./styles.css";
export var Stepper = function (props) {
    var activeStep = props.activeStep !== undefined ? props.activeStep : 0;
    return (React.createElement("div", { className: "mdl-card mdl-shadow--2dp" },
        React.createElement("div", { className: "mdl-card__supporting-text" },
            React.createElement("div", { className: "mdl-stepper-horizontal-alternative" }, React.Children.map(props.children, function (child, index) {
                if (child !== undefined && child.type === Step) {
                    return (React.createElement(Step, { active: activeStep >= index, stepNumber: props.withNumbers ? index + 1 : null, done: activeStep > index }, child.props.children));
                }
            })))));
};
